import { Box } from '@mui/material';
import { FC } from 'react';
import { FeatureLayout } from '@lendica/components';
import { BasicTabs } from './components/BasicTabs';
import { Route, Routes } from 'react-router-dom';
import { UpcomingPayments } from './views/UpcomingPayments';
import { History } from './views/History';
import { useActivityCenter } from './hooks/useActivityCenter';
import { TransactionSummaryView } from './views/TransactionSummaryView';

export const ActivityCenter: FC = () => {
    const { isLoading, payments, isInitialLoading, isFetchingMore, hasNext, loadMore } =
        useActivityCenter();

    return (
        <FeatureLayout loading={isLoading}>
            <Box
                sx={{
                    pb: 2,
                    px: 2,
                    pt: 1,
                    boxSizing: 'border-box',
                    maxWidth: 480,
                    height: '100%',
                    overflow: 'hidden',
                }}
            >
                <Routes>
                    <Route
                        path="/"
                        element={
                            <BasicTabs
                                labels={['Upcoming', 'History']}
                                contents={[
                                    <UpcomingPayments
                                        payments={payments}
                                        isInitialLoading={isInitialLoading}
                                        isFetchingMore={isFetchingMore}
                                        hasNext={hasNext}
                                        loadMore={loadMore}
                                    />,
                                    <History
                                        payments={payments}
                                        isInitialLoading={isInitialLoading}
                                        isFetchingMore={isFetchingMore}
                                        hasNext={hasNext}
                                        loadMore={loadMore}
                                    />,
                                ]}
                            />
                        }
                    />
                    <Route
                        path="/detail/:transactionId"
                        element={<TransactionSummaryView payments={payments} />}
                    />
                </Routes>
            </Box>
        </FeatureLayout>
    );
};
